import React from 'react';

const PersonLockSVG = ({ className, subClassName }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M61.1669 36C61.1669 37.3499 60.0725 38.4444 58.7224 38.4444H44.0558C42.7057 38.4444 41.6113 37.3499 41.6113 36V26.2222C41.6113 24.8721 42.7057 23.7778 44.0558 23.7778V21.3333C44.0558 17.2832 47.339 14 51.3891 14C55.4392 14 58.7224 17.2832 58.7224 21.3333V23.7778C60.0725 23.7778 61.1669 24.8721 61.1669 26.2222V36ZM51.3891 28.6667C50.039 28.6667 48.9447 29.761 48.9447 31.1111C48.9447 32.461 50.039 33.5556 51.3891 33.5556C52.7392 33.5556 53.8336 32.461 53.8336 31.1111C53.8336 29.761 52.7392 28.6667 51.3891 28.6667ZM51.3891 16.4444C48.6934 16.4444 46.5002 18.6376 46.5002 21.3333V23.7778H56.278V21.3333C56.278 18.6376 54.0849 16.4444 51.3891 16.4444Z"
        fill="none"
        className={subClassName}
      />
      <path
        d="M24.0238 40.625C25.8368 40.625 27.6091 40.0862 29.1165 39.0766C30.624 38.0671 31.7989 36.6322 32.4927 34.9534C33.1865 33.2746 33.368 31.4273 33.0143 29.6451C32.6606 27.8629 31.7876 26.2259 30.5056 24.941C29.2236 23.6561 27.5903 22.781 25.8121 22.4265C24.034 22.072 22.1909 22.254 20.5159 22.9494C18.8409 23.6447 17.4093 24.8223 16.402 26.3332C15.3948 27.8441 14.8571 29.6204 14.8571 31.4375C14.8571 33.8742 15.8229 36.2111 17.542 37.934C19.2611 39.657 21.5927 40.625 24.0238 40.625ZM33.1905 45.875H14.8571C12.7733 45.875 10.7748 46.7047 9.3013 48.1815C7.8278 49.6584 7 51.6614 7 53.75V59H41.0476V53.75C41.0476 51.6614 40.2198 49.6584 38.7463 48.1815C37.2728 46.7047 35.2743 45.875 33.1905 45.875Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const SelfAccountUnlockSvg = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      className="dashboard-icon"
    >
      <path
        d="M23.0733 25.9267V31.8012H20.0916C18.9346 31.8012 18 32.7359 18 33.8928V54.1415C18 55.2985 18.9347 56.2332 20.0916 56.2332H49.9084C51.0654 56.2332 52 55.2984 52 54.1415V33.8928C52 32.7358 51.0653 31.8012 49.9084 31.8012H46.9267L46.9264 25.9267C46.9264 19.3404 41.5862 14 34.9997 14C28.4132 14 23.073 19.3402 23.073 25.9267H23.0733ZM37.5812 48.6675C37.759 49.335 37.2251 50.0027 36.5577 50.0027H33.4426C32.7305 50.0027 32.2409 49.3353 32.4191 48.6675L33.3981 44.8847C32.2412 44.306 31.4399 43.1047 31.4399 41.6805C31.4399 39.6779 33.042 38.0758 35.0446 38.0758C37.0471 38.0758 38.6492 39.6779 38.6492 41.6805C38.6492 43.1047 37.8483 44.306 36.691 44.8847L37.5812 48.6675ZM40.9633 25.9267V31.8012H29.0366V25.9267C29.0366 22.6334 31.7069 19.9634 34.9998 19.9634C38.2931 19.9634 40.9631 22.6337 40.9631 25.9267H40.9633Z"
        //fill="#00205C"
        className={className}
      />
    </svg>
  );
};

const GearEditSVG = ({ className }) => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="dashboard-icon"
  >
    <path
      d="M26.8646 44.4484L29.762 41.551C24.5167 41.2513 20.3206 36.9053 20.3206 31.5601C20.3206 26.0152 24.8165 21.5693 30.3115 21.5693C35.6566 21.5693 40.0026 25.7155 40.3023 31.0106L45.048 26.265C44.6983 25.3158 44.2487 24.3667 43.7492 23.5175L45.9971 20.6201C46.2469 20.2705 46.2469 19.8209 45.9472 19.5211L42.4004 15.9744C42.1007 15.6747 41.6511 15.6247 41.3014 15.9244L38.4041 18.1724C37.0553 17.3731 35.6066 16.7737 34.108 16.374L33.6584 12.7273C33.6084 12.3277 33.2588 12.028 32.8591 12.028H27.8637C27.4641 12.028 27.1144 12.3277 27.0145 12.7773L26.5649 16.424C25.0163 16.8236 23.6176 17.4231 22.2688 18.2223L19.3714 15.9744C19.0218 15.7246 18.5722 15.7246 18.2725 16.0243L14.7257 19.5211C14.426 19.8209 14.426 20.2705 14.6757 20.6201L16.9237 23.5175C16.1244 24.8163 15.525 26.265 15.1253 27.8136L11.5286 28.2632C11.129 28.3131 10.7793 28.6628 10.7793 29.0624V34.0579C10.7793 34.4575 11.079 34.8072 11.5286 34.9071L15.1253 35.3567C15.525 36.9053 16.1244 38.304 16.9237 39.6528L14.6757 42.5501C14.426 42.8998 14.426 43.3494 14.7257 43.6491L18.2725 47.1459C18.5722 47.4456 19.0218 47.4956 19.3714 47.2458L22.2688 44.9979C23.168 45.5474 24.1671 46.0469 25.2161 46.3966C25.7157 45.6972 26.2652 45.0978 26.8646 44.4484Z"
      fill="none"
      className={className}
    />
    <path
      d="M30.3112 37.6546C33.6771 37.6546 36.4057 34.926 36.4057 31.5601C36.4057 28.1943 33.6771 25.4657 30.3112 25.4657C26.9454 25.4657 24.2168 28.1943 24.2168 31.5601C24.2168 34.926 26.9454 37.6546 30.3112 37.6546Z"
      fill="none"
      className={className}
    />
    <path
      d="M25.2161 54.2395L24.5667 57.0869C24.4668 57.6364 24.9164 58.0859 25.4659 57.986L28.3133 57.3366C30.5113 56.8371 32.5594 55.888 34.3078 54.5392L28.0136 48.2449C26.6648 49.9933 25.6657 52.0415 25.2161 54.2395Z"
      fill="none"
      className={className}
    />
    <path
      d="M45.4427 30.5963L30.2539 45.7851L36.718 52.2492L51.9067 37.0604L45.4427 30.5963Z"
      fill="none"
      className={className}
    />
    <path
      d="M57.6864 28.8126L53.69 24.8163C52.9907 24.1169 51.9416 24.067 51.3422 24.7164L47.7954 28.2631L54.2895 34.7572L57.8362 31.2104C58.4357 30.561 58.3857 29.512 57.6864 28.8126Z"
      fill="none"
      className={className}
    />
  </svg>
);

const EnvelopeSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M16.3846 17.7693C15.7193 17.7693 15.1087 17.9741 14.5865 18.3158L33.6426 36.367C34.4774 37.1583 35.5592 37.1582 36.3926 36.367L55.4134 18.3158C54.8912 17.9741 54.2806 17.7693 53.6153 17.7693H16.3846ZM13.2115 20.0962C13.0826 20.4688 13 20.8574 13 21.2773V44.7227C13 45.4351 13.1984 46.0916 13.5465 46.6442L27.0144 33.1939L13.2115 20.0962ZM56.7884 20.0962L43.0208 33.1763L56.4534 46.6442C56.8015 46.0916 56.9999 45.4351 56.9999 44.7227V21.2773C56.9999 20.8574 56.9173 20.4688 56.7884 20.0962ZM41.3813 34.7452L37.9439 38.0064C36.307 39.5605 33.7285 39.5583 32.0913 38.0064L28.6538 34.7628L15.3269 48.0544C15.6602 48.1678 16.0139 48.2307 16.3846 48.2307H53.6153C53.986 48.2307 54.3396 48.1678 54.673 48.0544L41.3813 34.7452Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const EnrollmentRulesSVG = ({ className }) => {
  return (
    <svg
      width="51"
      height="70"
      viewBox="0 0 51 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M26.4875 11.448H33.4602C34.1574 11.448 34.6938 10.9116 34.6938 10.2143C34.6938 9.51707 34.1574 8.98071 33.4602 8.98071H26.4875C25.7902 8.98071 25.2538 9.51707 25.2538 10.2143C25.2538 10.9116 25.7902 11.448 26.4875 11.448Z"
        fill="none"
        className={className}
      />
      <path
        d="M16.7794 10.9652L18.3348 12.6279C18.5494 12.8961 18.9248 13.0033 19.2466 13.0033C19.5684 13.0033 19.9439 12.8424 20.1584 12.6279L23.0548 9.51698C23.5375 9.03425 23.4839 8.22971 23.0012 7.74699C22.5184 7.26426 21.7139 7.3179 21.2312 7.80062L19.2466 9.94607L18.603 9.2488C18.1203 8.76607 17.3157 8.71244 16.833 9.19516C16.3503 9.67789 16.2966 10.4824 16.7794 10.9652Z"
        fill="none"
        className={className}
      />
      <path
        d="M26.4875 18.3135H33.4602C34.1574 18.3135 34.6938 17.7771 34.6938 17.0798C34.6938 16.3826 34.1574 15.8462 33.4602 15.8462H26.4875C25.7902 15.8462 25.2538 16.3826 25.2538 17.0798C25.2538 17.7771 25.7902 18.3135 26.4875 18.3135Z"
        fill="none"
        className={className}
      />
      <path
        d="M21.2312 14.6661L19.2466 16.8115L18.603 16.1143C18.1203 15.6315 17.3157 15.5779 16.833 16.0606C16.3503 16.5433 16.2966 17.3479 16.7794 17.8306L18.3348 19.4933C18.5494 19.7615 18.9248 19.8688 19.2466 19.8688C19.5684 19.8688 19.9439 19.7079 20.1584 19.4933L23.0548 16.3824C23.5375 15.8997 23.4839 15.0952 23.0012 14.6124C22.4648 14.1297 21.7139 14.1297 21.2312 14.6661Z"
        fill="none"
        className={className}
      />
      <path
        d="M26.4875 25.2324H33.4602C34.1574 25.2324 34.6938 24.696 34.6938 23.9988C34.6938 23.3015 34.1574 22.7651 33.4602 22.7651H26.4875C25.7902 22.7651 25.2538 23.3015 25.2538 23.9988C25.2538 24.696 25.7902 25.2324 26.4875 25.2324Z"
        fill="none"
        className={className}
      />
      <path
        d="M21.2312 21.5317L19.2466 23.6771L18.603 23.0335C18.1203 22.5508 17.3157 22.4971 16.833 22.9798C16.3503 23.4626 16.2966 24.2671 16.7794 24.7498L18.3348 26.4126C18.5494 26.6807 18.9248 26.788 19.2466 26.788C19.5684 26.788 19.9439 26.6271 20.1584 26.4126L23.0548 23.3017C23.5375 22.8189 23.4839 22.0144 23.0012 21.5317C22.4648 20.9953 21.7139 20.9953 21.2312 21.5317Z"
        fill="none"
        className={className}
      />
      <path
        d="M45.0456 0.935303C42.3101 0.935303 17.2084 0.935303 17.2084 0.935303C13.0248 0.935303 9.64574 4.31438 9.64574 8.498V30.167H1.33214C0.634872 30.167 0.0985107 30.7034 0.0985107 31.4006V34.5652C0.0985107 38.7488 3.47759 42.1278 7.6612 42.1278H35.4984C38.8238 42.1278 41.5056 39.446 41.5056 36.1206V13.3252H49.7656C50.4628 13.3252 50.9992 12.7889 50.9992 12.0916V6.94255C51.0528 3.61711 48.371 0.935303 45.0456 0.935303ZM7.6612 39.6606C4.87213 39.6606 2.56577 37.4079 2.56577 34.5652V32.6879H29.4911V36.1206C29.4911 37.4079 29.9202 38.6415 30.6175 39.6069H7.6612V39.6606ZM39.0383 6.94255V36.1742C39.0383 38.1051 37.4829 39.6606 35.552 39.6606C33.6211 39.6606 32.0656 38.1051 32.0656 36.1742V31.4543C32.0656 30.757 31.5293 30.2206 30.832 30.2206H12.113V8.498C12.113 5.70892 14.3657 3.40256 17.2084 3.40256H40.2183C39.4674 4.42165 39.0383 5.60165 39.0383 6.94255ZM48.5319 10.8043H41.5592V6.94255C41.5592 5.01165 43.1147 3.4562 45.0456 3.4562C46.9765 3.4562 48.5319 5.01165 48.5319 6.94255V10.8043Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const PreferencesSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M34.19 50.591L33.5287 51.25H32.5936H27.8042H25.5464V49V44.227V43.2951L26.2077 42.636L46.1635 22.7486L47.76 21.1576L48.1238 20.7951V17.5C48.1238 15.0146 46.1021 13 43.6084 13H23.2887L12 24.25V53.5C12 55.9852 14.0217 58 16.5155 58H43.6084C46.1021 58 48.1238 55.9852 48.1238 53.5V36.7051L34.19 50.591ZM15.3866 26.5L25.5464 16.375V26.5H15.3866ZM32.5936 49H27.8042V44.227L47.76 24.3397L52.5493 29.1125L32.5936 49ZM57.3388 24.3397L54.1459 27.5216L49.3565 22.7486L52.5493 19.5667C52.9903 19.1273 53.5681 18.9076 54.1459 18.9076C54.7237 18.9076 55.3015 19.1273 55.7423 19.5667L57.3388 21.1576C58.2204 22.0364 58.2204 23.4609 57.3388 24.3397Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const ManageResourcesSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.1124 50.0057H55.4822C56.6889 50.0057 57.6754 50.9903 57.6754 52.1977V54.5801C57.6754 55.7875 56.6889 56.7721 55.4822 56.7721H35.1124C33.9057 56.7721 32.9191 55.7875 32.9191 54.5801V52.1977C32.9191 50.9903 33.9057 50.0057 35.1124 50.0057ZM35.437 39.6651H55.8068C57.0135 39.6651 58 40.6496 58 41.8571V44.2395C58 45.4469 57.0135 46.4314 55.8068 46.4314H35.437C34.2303 46.4314 33.2437 45.4469 33.2437 44.2395V41.8571C33.2437 40.6496 34.2303 39.6651 35.437 39.6651ZM35.1124 24.2352H55.4822C56.6889 24.2352 57.6754 25.2212 57.6754 26.4272V28.8096C57.6754 30.017 56.6889 31.0015 55.4822 31.0015H35.1124C33.9057 31.0015 32.9191 30.017 32.9191 28.8096V26.4272C32.9191 25.2212 33.9057 24.2352 35.1124 24.2352ZM35.437 13.8945H55.8068C57.0135 13.8945 58 14.8805 58 16.0865V18.4703C58 19.6763 57.0135 20.6623 55.8068 20.6623H35.437C34.2303 20.6623 33.2437 19.6763 33.2437 18.4703V16.0865C33.2437 14.8805 34.2303 13.8945 35.437 13.8945ZM14.2401 39.6651H25.8116C27.3373 39.6651 28.5835 40.9106 28.5835 42.4368V54.0004C28.5835 55.5266 27.3373 56.7721 25.8116 56.7721H14.2401C12.713 56.7721 11.4668 55.5266 11.4668 54.0004V42.4368C11.4668 40.9106 12.713 39.6651 14.2401 39.6651ZM13.6487 48.6742C11.7208 46.4484 15.1123 43.5187 17.0374 45.7431L18.762 47.7418L23.2515 43.8699C25.4786 41.9445 28.4085 45.3354 26.1842 47.258L19.9955 52.5955C19.0598 53.4037 17.6442 53.3008 16.8341 52.3656L13.6487 48.6742ZM14.2401 13.8945H25.8116C27.3373 13.8945 28.5835 15.14 28.5835 16.6662V28.2312C28.5835 29.756 27.3373 31.0015 25.8116 31.0015H14.2401C12.713 31.0015 11.4668 29.756 11.4668 28.2312V16.6662C11.4668 15.14 12.713 13.8945 14.2401 13.8945ZM19.016 17.8187L20.028 18.83L21.0385 17.8201C23.4307 15.425 27.0536 19.0444 24.66 21.4395L23.6495 22.4495L24.6586 23.4594C27.0536 25.8517 23.4321 29.4725 21.0371 27.0788L20.028 26.0689L19.016 27.0788C16.6196 29.4711 12.9981 25.8545 15.3946 23.4594L16.4065 22.4495L15.3946 21.4381C12.9981 19.0444 16.621 15.425 19.016 17.8187Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const ManageContactsSVG = ({ className }) => {
  return (
    <svg
      width="72"
      height="70"
      viewBox="0 0 72 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M42.6786 31.1406C40.8429 32.2624 38.6503 32.8744 36.3556 32.8744C34.061 32.8744 31.8684 32.2624 30.0326 31.1406C27.2281 32.3134 24.7805 34.3021 23.0977 36.8517L23.9136 39.9622C24.4235 41.9509 23.4037 44.0416 21.517 44.9594L21.364 45.0104C21.619 45.6223 21.9759 46.2852 22.4348 46.9991C22.8428 47.662 23.3017 48.2739 23.7096 48.7328L23.8626 48.6309C24.6275 48.019 25.5963 47.662 26.5652 47.662C27.585 47.662 28.5539 48.019 29.3697 48.6819L33.0922 51.8943H49.5626C51.0413 51.8943 52.2651 50.6705 52.2651 49.1918V45.5204C52.2651 39.0444 48.2878 33.4863 42.6786 31.1406Z"
        fill="none"
        className={className}
      />
      <path
        d="M36.3551 30.071C41.6072 30.071 45.8906 25.7877 45.8906 20.5355C45.8906 15.2833 41.6072 11 36.3551 11C31.1029 11 26.8196 15.2833 26.8196 20.5355C26.8196 25.7877 31.0519 30.071 36.3551 30.071Z"
        fill="none"
        className={className}
      />
      <path
        d="M27.5327 50.8255C26.9718 50.3666 26.1559 50.3666 25.595 50.8255L23.5043 52.5082C22.1276 51.2844 21.1077 50.2136 20.0369 48.4799C18.9151 46.6442 18.4051 45.2164 17.9462 43.4827L20.3938 42.3608C21.0567 42.0549 21.4137 41.341 21.2097 40.6271L19.9349 35.7319C19.7309 34.865 18.8131 34.4061 17.9462 34.712L14.6827 35.9359C13.9179 36.2418 13.3569 36.9047 13.255 37.6696C13.102 38.4855 13 39.5053 13 40.2702C13.102 43.6356 14.3258 47.3581 16.4165 50.7235C18.5581 54.14 21.3627 56.8426 24.3202 58.4233C24.9831 58.7802 26.0029 59.0862 26.7678 59.3412C27.5327 59.5961 28.3996 59.3921 29.0115 58.7802L31.5101 56.3326C32.122 55.7207 32.122 54.7009 31.4591 54.089L27.5327 50.8255Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const ConfigureLinksSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <rect x="12" y="44" width="44" height="3" fill="#0A7593" />
      <path
        d="M36 45H32C31.448 45 31 45.448 31 46C31 46.552 31.448 47 32 47H36C36.552 47 37 46.552 37 46C37 45.448 36.552 45 36 45ZM22 47H26C26.552 47 27 46.552 27 46C27 45.448 26.552 45 26 45H22C21.448 45 21 45.448 21 46C21 46.552 21.448 47 22 47ZM52 13H16C13.244 13 11 15.244 11 18V52C11 54.756 13.244 57 16 57H52C54.756 57 57 54.756 57 52V18C57 15.244 54.756 13 52 13ZM24 17C24.552 17 25 17.448 25 18C25 18.552 24.552 19 24 19C23.448 19 23 18.552 23 18C23 17.448 23.448 17 24 17ZM20 17C20.552 17 21 17.448 21 18C21 18.552 20.552 19 20 19C19.448 19 19 18.552 19 18C19 17.448 19.448 17 20 17ZM16 17C16.552 17 17 17.448 17 18C17 18.552 16.552 19 16 19C15.448 19 15 18.552 15 18C15 17.448 15.448 17 16 17ZM55 45H52C51.448 45 51 45.448 51 46C51 46.552 51.448 47 52 47H55V52C55 53.654 53.654 55 52 55H16C14.346 55 13 53.654 13 52V47H16C16.552 47 17 46.552 17 46C17 45.448 16.552 45 16 45H13V23H55V45ZM42 47H46C46.552 47 47 46.552 47 46C47 45.448 46.552 45 46 45H42C41.448 45 41 45.448 41 46C41 46.552 41.448 47 42 47Z"
        fill="none"
        className={className}
      />
      <path
        d="M35.0054 39.5972L37.2974 37.3052C37.6874 36.9152 38.3214 36.9152 38.7114 37.3052C39.1014 37.6952 39.1014 38.3292 38.7114 38.7192L34.7114 42.7192C34.5814 42.8492 34.4194 42.9192 34.2534 42.9632C34.2134 42.9752 34.1774 42.9812 34.1354 42.9872C33.9634 43.0112 33.7894 43.0052 33.6254 42.9372L33.6234 42.9372C33.6194 42.9352 33.6174 42.9312 33.6134 42.9292C33.5014 42.8792 33.3934 42.8132 33.2994 42.7192L29.2974 38.7192C28.9074 38.3292 28.9074 37.6952 29.2974 37.3052C29.4934 37.1112 29.7494 37.0132 30.0054 37.0132C30.2614 37.0132 30.5174 37.1092 30.7134 37.3052L33.0054 39.5972L33.0054 32.0112C33.0054 31.4592 33.4534 31.0112 34.0054 31.0112C34.5574 31.0112 35.0054 31.4592 35.0054 32.0112L35.0054 39.5972Z"
        fill="#0A7593"
      />
    </svg>
  );
};

const SocialMediaSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M47.7724 9.42969H23.2276C17.5787 9.42969 13 14.077 13 19.8107V37.9922C13 43.7259 17.5787 48.3738 23.2276 48.3738H29.1314L35.5 59.5725L41.8686 48.3744H47.7724C53.4213 48.3744 58 43.7265 58 37.9928V19.8107C58 14.077 53.4213 9.42969 47.7724 9.42969ZM27.9731 37.8744C27.9731 39.4742 26.6975 40.7684 25.1216 40.7684C23.5468 40.7684 22.2701 39.4742 22.2701 37.8744V29.099C22.2701 27.4986 23.5468 26.2062 25.1216 26.2062C26.6975 26.2062 27.9731 27.4992 27.9731 29.099V37.8744ZM48.7304 36.3469C48.7304 38.7892 46.7785 40.7678 44.3719 40.7678H33.3352C30.927 40.7678 28.9778 38.7886 28.9778 36.3469V30.6271C28.9778 28.4851 30.4775 26.6999 32.4682 26.291C34.3707 23.4508 35.2656 20.9409 35.2656 20.9409C35.2656 20.9409 35.5233 19.8338 35.9625 18.5661C36.0092 18.3726 36.0775 18.1872 36.1639 18.014C36.5804 17.1789 37.4332 16.6054 38.4186 16.6054C39.5912 16.6054 40.576 17.4139 40.8605 18.5141C40.8912 18.6342 40.9145 18.755 40.9287 18.8809C41.3947 21.7731 40.4064 24.5718 39.6407 26.2056H44.3719C46.7785 26.2056 48.7304 28.1842 48.7304 30.6265V36.3469Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};
const SecuritySettingsSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M23.0733 25.9267V31.8012H20.0916C18.9346 31.8012 18 32.7359 18 33.8928V54.1415C18 55.2985 18.9347 56.2332 20.0916 56.2332H49.9084C51.0654 56.2332 52 55.2984 52 54.1415V33.8928C52 32.7358 51.0653 31.8012 49.9084 31.8012H46.9267L46.9264 25.9267C46.9264 19.3404 41.5862 14 34.9997 14C28.4132 14 23.073 19.3402 23.073 25.9267H23.0733ZM37.5812 48.6675C37.759 49.335 37.2251 50.0027 36.5577 50.0027H33.4426C32.7305 50.0027 32.2409 49.3353 32.4191 48.6675L33.3981 44.8847C32.2412 44.306 31.4399 43.1047 31.4399 41.6805C31.4399 39.6779 33.042 38.0758 35.0446 38.0758C37.0471 38.0758 38.6492 39.6779 38.6492 41.6805C38.6492 43.1047 37.8483 44.306 36.691 44.8847L37.5812 48.6675ZM40.9633 25.9267V31.8012H29.0366V25.9267C29.0366 22.6334 31.7069 19.9634 34.9998 19.9634C38.2931 19.9634 40.9631 22.6337 40.9631 25.9267H40.9633Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};
const PriceCompareSVG = ({ className }) => {
  return (
    <svg
      width="33"
      height="70"
      viewBox="0 0 33 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M12.7273 3.63636H3.63636C1.63636 3.63636 0 5.27273 0 7.27273V32.7273C0 34.7273 1.63636 36.3636 3.63636 36.3636H12.7273V40H16.3636V0H12.7273V3.63636ZM12.7273 30.9091H3.63636L12.7273 20V30.9091ZM29.0909 3.63636H20V7.27273H29.0909V30.9091L20 20V36.3636H29.0909C31.0909 36.3636 32.7273 34.7273 32.7273 32.7273V7.27273C32.7273 5.27273 31.0909 3.63636 29.0909 3.63636Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};
const AdminConfigurationSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M55.7688 19.2166C55.6823 18.1821 55.2252 17.2122 54.481 16.4821C53.7367 15.752 52.7534 15.3093 51.709 15.2344C45.8645 14.753 42.9342 13.0155 38.3885 9.07501C37.5889 8.38219 36.5626 8 35.5005 8C34.4383 8 33.412 8.38218 32.6124 9.07501C28.0668 13.0155 25.1365 14.753 19.2919 15.2344C18.2475 15.3093 17.2642 15.752 16.5199 16.4821C15.7757 17.2122 15.3187 18.182 15.2321 19.2166C14.4506 29.1593 14.4506 55 35.5 55C56.5493 55 56.5494 29.1751 55.7679 19.2166H55.7688ZM35.5009 17.8404C37.1489 17.8404 38.7296 18.4894 39.8948 19.6444C41.0603 20.7996 41.7148 22.366 41.7148 23.9998C41.7148 25.6332 41.0604 27.1996 39.8948 28.3549C38.7296 29.5098 37.1489 30.1589 35.5009 30.1589C33.8529 30.1589 32.2723 29.5098 31.1071 28.3549C29.9415 27.1996 29.2871 25.6332 29.2871 23.9998C29.2871 22.366 29.9415 20.7996 31.1071 19.6444C32.2723 18.4895 33.8529 17.8404 35.5009 17.8404ZM45.7697 36.3755C45.7697 39.0646 44.6913 41.6439 42.7723 43.545C40.8533 45.446 38.251 46.5134 35.5376 46.5119H35.4636H35.4639C32.7505 46.5133 30.1483 45.446 28.2292 43.545C26.3102 41.6439 25.2319 39.0647 25.2319 36.3755V35.329C25.2326 34.88 25.3832 34.4441 25.6602 34.0889C25.9371 33.7341 26.3249 33.4801 26.7631 33.3665L31.1718 32.236H31.1714C31.6012 32.1269 32.0552 32.159 32.4648 32.328C32.8743 32.497 33.2172 32.7938 33.4418 33.1731L33.7375 33.6651V33.6647C34.1039 34.2856 34.7753 34.6671 35.5008 34.6671C36.2263 34.6671 36.8976 34.2857 37.2641 33.6647L37.5598 33.1727V33.1731C37.7844 32.7938 38.1273 32.497 38.5368 32.328C38.9463 32.159 39.4004 32.1269 39.8302 32.236L44.2388 33.3665H44.2385C44.6767 33.4801 45.0645 33.7341 45.3414 34.0889C45.6184 34.4441 45.769 34.8799 45.7697 35.329L45.7697 36.3755Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const ReportsSVG = ({ className }) => {
  return (
    <svg
      width="33"
      height="70"
      viewBox="0 0 33 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M32.1668 12.6667L20.4168 0.916748H4.75016C3.7114 0.916748 2.71518 1.3294 1.98066 2.06391C1.24614 2.79843 0.833496 3.79465 0.833496 4.83341V36.1667C0.833496 37.2055 1.24614 38.2017 1.98066 38.9362C2.71518 39.6708 3.7114 40.0834 4.75016 40.0834H28.2502C29.2889 40.0834 30.2851 39.6708 31.0197 38.9362C31.7542 38.2017 32.1668 37.2055 32.1668 36.1667V12.6667ZM10.6252 34.2084H6.7085V16.5834H10.6252V34.2084ZM18.4585 34.2084H14.5418V22.4584H18.4585V34.2084ZM26.2918 34.2084H22.3752V28.3334H26.2918V34.2084ZM20.4168 14.6251H18.4585V4.83341L28.2502 14.6251H20.4168Z"
        fill="none"
        className={className}
      />
    </svg>
  );
};

const SearchSVG = ({ className }) => {
  return (
    <svg
      width="38"
      height="70"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M36.9756 34.8164L27.9509 25.7963C30.2118 23.0371 31.4515 19.5843 31.4515 16.0184C31.4515 7.50337 24.5257 0.578979 16.0172 0.578979C13.9372 0.578979 11.9174 0.986075 10.0145 1.79273C8.17568 2.57299 6.52523 3.68496 5.10841 5.10226C3.69159 6.51955 2.57622 8.17055 1.79621 10.01C0.98983 11.9136 0.579102 13.934 0.579102 16.0147C0.579102 24.5297 7.50495 31.4541 16.0134 31.4541C19.5819 31.4541 23.0297 30.214 25.788 27.9524L34.8052 36.9725C35.0953 37.2628 35.4797 37.4211 35.8866 37.4211C36.2973 37.4211 36.6817 37.2628 36.9681 36.9725C37.571 36.3807 37.571 35.412 36.9756 34.8164ZM28.3955 16.0147C28.3955 22.8448 22.8413 28.3971 16.0172 28.3971C9.18931 28.3971 3.63884 22.841 3.63884 16.0147C3.63884 9.18829 9.19308 3.63219 16.0172 3.63219C22.8413 3.63219 28.3955 9.18829 28.3955 16.0147Z"
        fill="#0A7593"
        className={className}
      />
    </svg>
  );
};

const DocumentsSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M51.1668 27.6665L39.4168 15.9165H23.7502C22.7114 15.9165 21.7152 16.3292 20.9807 17.0637C20.2461 17.7982 19.8335 18.7944 19.8335 19.8332V51.1665C19.8335 52.2053 20.2461 53.2015 20.9807 53.936C21.7152 54.6705 22.7114 55.0832 23.7502 55.0832H47.2502C48.2889 55.0832 49.2851 54.6705 50.0197 53.936C50.7542 53.2015 51.1668 52.2053 51.1668 51.1665V27.6665ZM39.4168 29.6248H37.4585V19.8332L47.2502 29.6248H39.4168Z"
        className={className}
      />
    </svg>
  );
};

const ApprovalSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1818 20.1818H19.5455C18.6924 20.1818 18 20.8742 18 21.7273V55.7273C18 56.5804 18.6924 57.2727 19.5455 57.2727H44.2727C45.1258 57.2727 45.8182 56.5804 45.8182 55.7273V51.0909H50.4545C51.3076 51.0909 52 50.3985 52 49.5455V15.5455C52 14.6924 51.3076 14 50.4545 14H25.7273C24.8742 14 24.1818 14.6924 24.1818 15.5455V20.1818ZM27.2727 20.1818H44.2727C45.1258 20.1818 45.8182 20.8742 45.8182 21.7273V48H48.9091V17.0909H27.2727V20.1818ZM25.7273 48H38.0909C38.944 48 39.6364 47.3076 39.6364 46.4545C39.6364 45.6015 38.944 44.9091 38.0909 44.9091H25.7273C24.8742 44.9091 24.1818 45.6015 24.1818 46.4545C24.1818 47.3076 24.8742 48 25.7273 48ZM25.7273 41.8182H38.0909C38.944 41.8182 39.6364 41.1258 39.6364 40.2727C39.6364 39.4196 38.944 38.7273 38.0909 38.7273H25.7273C24.8742 38.7273 24.1818 39.4196 24.1818 40.2727C24.1818 41.1258 24.8742 41.8182 25.7273 41.8182ZM24.6346 32.0926L27.7255 35.1835C28.0424 35.5004 28.4813 35.6642 28.9279 35.6317C29.3745 35.6008 29.7856 35.3767 30.0545 35.0182L34.6909 28.8364C35.2025 28.1533 35.0649 27.1843 34.3818 26.6727C33.6987 26.1612 32.7297 26.2987 32.2182 26.9818L28.6513 31.7387L26.8199 29.9074C26.2172 29.3046 25.2374 29.3046 24.6346 29.9074C24.0319 30.5101 24.0319 31.4899 24.6346 32.0926Z"
        fill="#0A7593"
        className={className}
      />
    </svg>
  );
};

const ManageHelpDocumentsSVG = ({ className }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dashboard-icon"
    >
      <path
        d="M35.0278 26.6111V60.25"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6387 38.625H49.4442"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6387 29.0139H49.4442"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4028 53.0417C12.7655 53.0417 12.1544 52.7885 11.7038 52.3379C11.2531 51.8873 11 51.2761 11 50.6389V19.4028C11 18.7655 11.2531 18.1544 11.7038 17.7038C12.1544 17.2531 12.7655 17 13.4028 17H25.4167C27.9657 17 30.4103 18.0126 32.2128 19.815C34.0152 21.6175 35.0278 24.0621 35.0278 26.6111C35.0278 24.0621 36.0404 21.6175 37.8428 19.815C39.6452 18.0126 42.0899 17 44.6389 17H56.6528C57.29 17 57.9012 17.2531 58.3518 17.7038C58.8024 18.1544 59.0556 18.7655 59.0556 19.4028V50.6389C59.0556 51.2761 58.8024 51.8873 58.3518 52.3379C57.9012 52.7885 57.29 53.0417 56.6528 53.0417H42.2361C40.3243 53.0417 38.4909 53.8011 37.1391 55.1529C35.7872 56.5048 35.0278 58.3382 35.0278 60.25C35.0278 58.3382 34.2683 56.5048 32.9165 55.1529C31.5647 53.8011 29.7312 53.0417 27.8194 53.0417H13.4028Z"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6108 38.625H25.4164"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6108 29.0139H25.4164"
        className={className}
        strokeWidth="3.29524"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export {
  PersonLockSVG,
  GearEditSVG,
  EnvelopeSVG,
  EnrollmentRulesSVG,
  PreferencesSVG,
  ManageResourcesSVG,
  ManageContactsSVG,
  ConfigureLinksSVG,
  SocialMediaSVG,
  SecuritySettingsSVG,
  PriceCompareSVG,
  AdminConfigurationSVG,
  ReportsSVG,
  SearchSVG,
  DocumentsSVG,
  ApprovalSVG,
  ManageHelpDocumentsSVG,
  SelfAccountUnlockSvg,
};
